<template>
  <div class="contents">
    <div class="zyk-search-wrapper-box">
      <div class="zyk-search-wrapper">
        <div class="zyk-search-con">
          <h2>招生计划（3+2+1）</h2>
        </div>
      </div>
    </div>

    <div class="list" style="min-height: 300px">
      <el-form inline v-model="query">
        <el-form-item label="考生省份" label-width="100px" @change="query.page=1,getList()">
          <el-select
            v-model="query.province"
            style="width: 192px"
            placeholder="请选择"
            size="small"
            clearable>
            <el-option
              v-for="item in cityData"
              :key="item.title"
              :label="item.title"
              :value="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高校省份" label-width="100px">
          <el-select
            v-model="query.collegeProvince"
            style="width: 192px"
            placeholder="请选择"
            size="small"
            clearable  @change="query.page=1,getList()">
            <el-option
              v-for="item in cityData"
              :key="item.title"
              :label="item.title"
              :value="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批次" label-width="100px">
          <el-select
            v-model="query.batch"
            style="width: 192px"
            placeholder="请选择"
            size="small"
            clearable  @change="query.page=1,getList()">
            <el-option
              v-for="item in batch_arr"
              :key="item"
              :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组别" label-width="100px">
          <el-select
            v-model="query.group_d"
            style="width: 192px"
            placeholder="请选择"
            size="small"
            clearable  @change="query.page=1,getList()" >
            <el-option
              v-for="item in group_arr"
              :key="item"
              :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="高校省份" label-width="100px">
               <el-input placeholder="请输入" style="width: 192px;" clearable v-model="query.collegeProvince" size="small"></el-input>
      	  </el-form-item>
      	  <el-form-item label="高校城市" label-width="100px">
               <el-input placeholder="请输入" style="width: 192px;" clearable v-model="query.collegeCity" size="small"></el-input>
      	  </el-form-item> -->
        <el-form-item label="高校名称" label-width="100px">
          <el-input
           @keyup.enter.native="query.page=1,getList()"
            placeholder="请输入"
            style="width: 192px"
            clearable
            v-model="query.collegeName"
            size="small"></el-input>
        </el-form-item>
        <el-form-item label="专业名称" label-width="100px">
          <el-input
           @keyup.enter.native="query.page=1,getList()"
            placeholder="请输入"
            style="width: 192px"
            clearable
            v-model="query.specialty_title"
            size="small"></el-input>
        </el-form-item>
<!--        <el-form-item label="年份" label-width="100px">
          <el-input
            style="width: 192px"
            v-model="query.year"
            disabled
            placeholder="请输入"
            clearable
            size="small"></el-input>
        </el-form-item> -->
        <el-form-item label-width="100px">
          <el-button
            type="success"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
            style="margin: 0px 2px">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f5f5' }"
        v-loading="loading">
        <el-table-column
          prop="code"
          label="院校代码" width="120"
          align="center"></el-table-column>
        <el-table-column label="院校名称" align="center">
          <template slot-scope="scope">
            <span @click="detail(scope.row)" style="cursor: pointer;color: #409EFF;">
              {{scope.row.collegeName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="所有专业" align="center" width="100">
          <template slot-scope="scope">
            <span  @click="zhuanyeLook(scope.row)" style="cursor: pointer;color: #409EFF;">
              点击查看
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="province"
          label="考生省份"
          align="center" width="120"></el-table-column>
        <el-table-column label="院校省份" align="center" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.collegeProvince || scope.row.collegeCity }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="collegeCity"
          label="高校城市" width="100"
          align="center"></el-table-column>
        <el-table-column
          prop="batch"
          label="批次名称"
          width="100"
          align="center"></el-table-column>
        <el-table-column
          prop="group_d"
          label="科类名称"
          width="200"
          align="center"></el-table-column>
      </el-table>
      <detail
        :info="detailInfo"
        :show.sync="dialog.detailDialogStatus"
        @refesh_list="getList" />
      <Zhuanye
        :info="detailInfo"
        :show.sync="dialog.zhuanyeDIALOG"
        @refesh_list="getList" />

      <div style="width: 100%; height: 80px"></div>
      <div class="bottom">
        <div
          style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="query.page"
            :page-sizes="[100]"
            :page-size="query.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cityJson from "@/utils/city.json";
import { RecruitData_index } from "@/api/gw/major.js";
import detail from "./components/detail.vue";
import Zhuanye from "./components/zhuanye.vue";
import { groupFind,batchGetgroup } from "@/api/gw/zonghe.js"
export default {
  computed: {
    ...mapGetters(["isLogin", "userinfo"]),
  },
  components: {
    detail,
    Zhuanye,
  },
  watch:{
    ["query.batch"](e){
      if(e){
        this.group_arr = [];
        this.query.group_d = ""
        this.batchGetgroup(e);
      }
    }
  },
  data() {
    return {
      cityData: cityJson,
      query: {
        page: 1,
        limit: 100,
        province: "河北省", //考生省份
        group_d: "", //组别
        batch: "", //批次
        collegeProvince: "", //高校省份
        collegeCity: "", //高校城市
        collegeName: "", //院校名称
        year: "", //查询年份
        specialty_title:"",//专业名称
      },
      loading: false,
      list: [],
      total: 0,
      detailInfo: {},
      dialog: {
        detailDialogStatus: false,
        zhuanyeDIALOG: false,
      },
      batch_arr:[],
      group_arr:[],
    };
  },
  mounted() {
    if (localStorage.getItem("qichengUserToken")) {
      this.$store.dispatch("getUserInfo").then(()=>{
        this.groupFind();
        this.getList();
      })
    }
  },
  methods: {
    groupFind(){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      groupFind({ examType }).then(res=>{
        this.batch_arr = res.data.batch_arr
        // this.group_arr = res.data.group_d_arr
      })
    },
    batchGetgroup(e){
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      batchGetgroup({ batch:e, examType }).then(res=>{
        this.group_arr = res.data
      })
    },
    getList(isZ) {
      this.loading = true;
      let searchData = { ...this.query };
      if (searchData.group_d == "物理组") {
        searchData["group_d"] = "物理科目组合";
      }
      if (searchData.group_d == "历史组") {
        searchData["group_d"] = "历史科目组合";
      }
      const examTypeRaw = localStorage.getItem('selectedExamType');
      const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
      searchData.examType = examType;
      RecruitData_index(searchData)
        .then((res) => {
          console.log("招生计划表", res);
          this.total = res.data.total;
          this.list = res.data.data;
          // this.query["year"] = res.current_year;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
       console.log(`每页 ${val} 条`);
       this.query.limit = val
       this.getList()
     },
     handleCurrentChange(val) {
       console.log(`当前页: ${val}`);
       this.query.page = val
       this.getList()
     },
    //查看所有专业
    zhuanyeLook(row) {
      this.dialog.zhuanyeDIALOG = true;
      let searchData = { ...this.query };
      if (searchData.group_d == "物理组") {
        searchData["group_d"] = "物理科目组合";
      }
      if (searchData.group_d == "历史组") {
        searchData["group_d"] = "历史科目组合";
      }
      this.detailInfo = {
        recruitdata_id: row.recruitdata_id,
        group_d: searchData.group_d,
        batch: searchData.batch,
      };
    },
    //查看院校
    detail(row) {
      this.dialog.detailDialogStatus = true;
      let searchData = { ...this.query };
      if (searchData.group_d == "物理组") {
        searchData["group_d"] = "物理科目组合";
      }
      if (searchData.group_d == "历史组") {
        searchData["group_d"] = "历史科目组合";
      }
      this.detailInfo = {
        recruitdata_id: row.recruitdata_id,
        group_d: searchData.group_d,
        batch: searchData.batch,
      };
    },
    handleSearch() {
      this.query.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  height: 60px;
  background: #fff;
  box-shadow: 0 0 8px #ddd;
  position: fixed;
  left: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list {
  width: 1250px;
  margin: 0 auto;
  padding-top: 30px;
}

.zyk-search-wrapper-box {
  background: linear-gradient(180deg, #49c48d, #1cb278);

  .zyk-search-wrapper {
    height: 200px;
    background: url(../../assets/banner-zyk-pc.png) no-repeat top;
    text-align: center;

    .zyk-search-con {
      width: 520px;
      padding-top: 36px;
      margin: 0 auto;

      h2 {
        height: 53px;
        font-size: 38px;
        font-weight: 600;
        color: #fff;
        line-height: 53px;
        text-shadow: 0 2px 2px rgba(0, 0, 0, 0.06);
        margin-bottom: 20px;
        letter-spacing: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RecruitData/index.vue